import { request } from 'src/common/request';

export const getUserInfoByApi = async (userId: string) => {
  const recordInfo = await request.editor.queryRecords({
    requests: [{ id: userId, table: 'user' }],
  });
  return recordInfo.users?.[userId || ''];
};
